import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { company, reels } from '../data/company';
export function Reels() {
  return <section className="bg-ink" data-id="element-169" data-mp="1dfcw2rslcew6">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 lg:grid-cols-[1fr_auto] lg:items-center lg:py-28" data-id="element-170" data-mp="1diseo4lh462c">
        <div className="max-w-md" data-id="element-171" data-mp="1nevf960ofwn6">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-gold" data-id="element-172" data-mp="1ne2csh8r3tau">
            On video
          </p>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-white sm:text-4xl" data-id="element-173" data-mp="pt6fhh53pquc">
            Watch the satisfying part.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-white/70" data-id="element-174" data-mp="zpsw1tqe9vqk">
            We film jobs as we go — roofs, driveways, and decks going from grimy
            to clean in a single pass.
          </p>
          <a href={company.facebook} target="_blank" rel="noreferrer" className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-gold underline decoration-gold/40 decoration-2 underline-offset-[6px] hover:decoration-gold" data-id="element-175" data-mp="71dofs9lefp9">
            More on Facebook
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" data-id="element-176" data-mp="20rampco8ltlu" />
          </a>
        </div>

        <div className="flex flex-wrap gap-5" data-id="element-177" data-mp="1vy7t54jgmk5n">
          {reels.map(src => <iframe key={src} src={src} title="North Star Exterior Cleaning job video" width={267} height={476} scrolling="no" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen className="overflow-hidden border-0 bg-ink-soft" data-id="element-178" data-mp="1ryh3x59l0c38" />)}
        </div>
      </div>
    </section>;
}